












































































































































































































































































































































































































































import { Component , Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwSteps } from '@libs-uuif/shared/sw-steps';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwModal ,  SwModalFooter , SwModalBody } from '@libs-uuif/shared/sw-modal';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import FileUpload from './file-upload.vue';
import { SwSpinningProgress } from '@libs-uuif/shared/sw-progress';
import ProductRegistrationDetails from './product-registration-details.vue';
import ManagementOption from './management-option.vue';
import RegisterCloudSecureEdge from './register-cloud-secure-edge.vue';
import { SwStatusInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-status-info';
import jsEncrypt from '@/shared/jsEncrypt';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { SetHelpContentIdPayload, InfoState } from '@/core/core.store';
import { Mutation } from 'vuex-class';
import { productsTab } from '../msw-products.route';
import { TooltipDirValues, tooltip } from '@sonicwall/unified-ui-framework/src/shared/tooltip-dir';
import MswStatusInfo from '@/core/msw-app-content/components/status-info.vue';
import { helpContentData } from '@/shared/help-content-data/msw-help-data.ts';
import MultiRegModal from './multireg-modal.vue';
import FileUploadmodal from './file-uploadmodal.vue';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { confirmService, ConfirmOptions, ConfirmButton } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { VNode, CreateElement } from 'vue';
import idb, { PRODUCTS_STORE_NAME } from '@/services/indexedDb.service';
import RegexValidators from '../../../shared/regex-validators';
import { envCongif } from '@/shared/env.config';

const cssPrefix = 'register-product';
const stepState = '--default';
const stepIndex = '1';
const LS_LASTSERIALTENANT = 'lastSerialTenantName';

@Component({
  components: {
    SwIcon,
    SwSteps,
    SwButton,
    SwTextfield,
    SwModal,
    SwModalFooter,
    SwModalBody,
    SwScrollView,
    FileUpload,
    SwRadio,
    SwSpinningProgress,
    ProductRegistrationDetails,
    ManagementOption,
    RegisterCloudSecureEdge,
    SwStatusInfo,
    productsTab,
    MswStatusInfo,
    MultiRegModal,
    FileUploadmodal,
  }, directives: {
    tooltip,
  },
})

export default class RegisterProducts extends SwExtendedVue {
  // ispSwitch : boolean = true;
  cssPrefix = cssPrefix;
  stepState = stepState;
  errorMessage = '';
  display2 :boolean = false;
  stepIndex = stepIndex;
  showAuthCode = false;
  authCode : string[] = [];
  friendlyName : string[] = [];
  iconConfig2 = {
    name: 'search',
    color: '#FF791A',
  };
  serialNumber : string[] = [];
  noOfField : number;
  csvData : any = [];
  customerName = '';
  threeAndFreeGroupID = '';
  customerNameSearch = '';
  currentStep = 0;
  moveFwd : boolean = false;
  changereg = 'Change register product type';
  customerNameInit: string[] = [];
  productGroupName: any[] = [];
  pageToShow: string = '';
  // keepAliveVar :boolean = false;
  noManagementLeft : boolean = false;
  managementOpt : any;
  retrienvedDataCalculated:boolean = false;
  affiliateTenantText: string = '';
  steps = [
    {
      label: '1',
      title: (this.$t('products.chooseATenant')
      .toString()),
      state: 'active',
    },
    {
      label: '2',
      title: (this.$t('products.productDetails')
      .toString()),
      state: 'default',
    },
    {
      label: '3',
      title: (this.$t('products.managementOpt')
      .toString()),
      state: 'default',
    },
  ];
  // managementPicked0:string = 'Unmanaged';
  // managementPicked1:string = 'Unmanaged';
  unFilteredCustomer: string[] = this.customerNameInit;
  filteredCustomers: string[] = this.unFilteredCustomer;
  registerSerialData : any;
  managementInputData : any;
  hesSerialNumber : string = '';
  defaultProductGroup : string = '';
  shownPages : any;
  mangOptRequiredflag : boolean = false;
  helplink:string = '';
  successResponse : any[] = [];
  successResponseMap : Map<number , any>;
  failureResponse : any[] = [];
  failureResponseMap : Map<number , any>;
  registrationValidityData : any[] = [];
  showMultiregModal : boolean = false;
  multiRegMode : string = '';
  batchId :string = '';
  cancelredirectUrl : string = '';
  options: ConfirmOptions;
  buttons: ConfirmButton[] =  [
    { key: 'cancel', name: (this.$t('common.cancel')
    .toString()), isDefault: true },
    { key: 'yes', name: (this.$t('common.yes')
    .toString()) },
  ];
  helpContentStep2 : any[] = [];
  helpContentStep3 : any[] = [];
  showCreateProductGroup : boolean = false;
  hostNameRegex = new RegExp(RegexValidators.domainPattern);
  subdomainRegex = new RegExp(RegexValidators.subdomainPattern);
  gmsRegex = new RegExp('^(?!.* .*)(?:[a-zA-Z0-9]{0,61}[a-zA-Z0-9][.:-])+[a-zA-Z0-9]{0,61}[a-zA-Z0-9]$');
  preSelectedTenant = '';
  showTZ80RegistrationModal: boolean = false;
  isTz80Strict: boolean = false;
  tZ80DataSheetLink: string = 'https://www.sonicwall.com/medialibrary/en/datasheet/tz-80.pdf';
  tZ80LicensingLink: string = 'https://www.sonicwall.com/techdocs/pdf/hardware/migration_requirements';
  addingAdditionalContactsLink: string = 'https://www.sonicwall.com/support/knowledge-base/how-to-add-a-renewal-contact-in-the-mysonicwall-account/220818091132313';
  sharedIconShowMap : Map<number , any>;
  tz80NsmOnPrem: any = {
    showModal: false,
  };
  cSEModal: any = {
    route:'',
    path:'',
    type:'',
  };
  cseAutoRedirect: string;

  selectCustomer(customerName : any) {
    if (this.productGroupName[this.unFilteredCustomer.indexOf(customerName)].isCanRegister) {
      this.showAffiliateText(customerName);
      this.customerName = customerName;
      this.customerNameSearch = customerName;
      this.currentStep += 1;
      this.steps[0].state = 'complete';
      this.steps[1].state = 'active';
      this.helpContentStep2 = [];
      this.helpContentStep2.push('register-default');
      this.helpContentStep2.push('bulkRegistration');
      this.resetHelpId(2);
    } else {
      const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('products.permissionErr')
      .toString()) };
      this.$store.commit('removeMessage', 0);
      this.$store.commit('enqueueMessage', message);
    }
  }
  showAffiliateText(customerName: any) {
    this.productGroupName.forEach((element : any)  => {
      if (element.productGroupName === customerName && element?.sharedGroup) {
        this.affiliateTenantText = element.sharedGroup === 'YES' ? element.affiliateTenantText : '';
      }
    });
  }
  get getCustomerName() {
    return this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)];
  }
  @Watch('display2')
  onDisplayChange() {
    // alert('changed');
  }

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  @Watch('customerNameSearch')
  searchCustomer() {
    this.filteredCustomers = this.unFilteredCustomer.filter(each => each.toLowerCase()
    .indexOf(this.customerNameSearch.toLowerCase()) > -1);
    if (this.unFilteredCustomer.indexOf(this.customerNameSearch)) {
      this.customerName = this.customerNameSearch;
    }
  }

  get validateSerialNumberData() {
    return this.$store.getters['MswProductsStoreModule/getValidateSerialNumberData'];
  }
  @Watch('validateSerialNumberData')
  onChange(data: any) {
    this.isTz80Strict = data?.isTz80 === 'STRICT';
    this.showTZ80RegistrationModal = data?.isTz80 === 'YES' || this.isTz80Strict;
  }

  moveFurther(value : any) {
    this.moveFwd = value;
  }

  cancelRegistration() {
    this.showTZ80RegistrationModal = false;
    this.goBackToProducts();
  }

  // recieving data from 2nd step comoponent
  retrievedData(value : any, processData ? : boolean) {
    this.registerSerialData = value;
    if (this.registerSerialData.response[1].content.isCSESeed === 'YES' || this.registerSerialData.response[1].content.isThreeandFreeCSE === 'YES') {
      if (!this.steps.find(itemContent => itemContent.label === '4')) {
        this.steps.push({
          label: '4',
          title: (this.$t('products.registercloudsecureedge')
          .toString()),
          state: 'default',
        });
      }
    }
    value.stepTwoShowFlag ? this.noManagementLeft = false : this.noManagementLeft = true;
    if (processData) {
      this.noManagementLeft = false;
      this.registerSerialData = value;
      let firewallCounter = 0;
      let wifiCounter = 0;
      let hesCounter = 0;
      let casCounter = 0;
      let sasCounter = 0;
      let cesCounter = 0;
      let sseCounter = 0;
      let tseCounter = 0;
      let tsmdrCounter = 0;
      let ccClientCounter = 0;
      let gmsSoftwareCounter = 0;
      let switchCounter = 0;
      let hesField = 0;
      let casField = 0;
      let sasField = 0;
      let cesField = 0;
      let sseField = 0;
      let tseField = 0;
      let tsemdrField = 0;
      let ccClientField = 0;
      let gmsSoftwareField = 0;
      let switchField = 0;
      let fwCSCManagement : boolean = false;
      let fwGMSManagement : boolean = false;
      let noNsmOnPremParentHelpText : string = '';
      let wfCSCManagement : boolean = false;
      let wfGMSManagement : boolean = false;
      let wfZT : boolean = false;
      let fwZT : boolean = false;
      let wifiField = -1;
      let firewallField = -1;
      let countryListField = -1;
      let showCountryDropdown : boolean = false;
      let catpDcListField = -1;
      let mdrDcListField = -1;
      let arrListField = -1;
      let gmsField = -1;
      let switchOptionLength = -1;
      let cloudTenantField = -1;
      const firewallIndex = [];
      const wifiIndex = [];
      if (value.response[1].content) {
        console.warn('looping for counts');
        for (let i = 1 ; i < value.serialNumber.length; i += 1) {
          if (value.response[i].content.hasOwnProperty('arrCaptureAtpDc')) {
            value.response[i].content.arrCaptureAtpDc.length > 0 ? catpDcListField = i : '';
          }
          if (value.response[i].content.isWifi) {
            wifiIndex.push(i);
            wifiCounter += 1;
            if (value.response[i].content.isWifi) {
              showCountryDropdown = true;
            }
          } else if (value.response[i].content.isHESservice) {
            hesCounter += 1;
            hesField = i;
          } else if (value.response[i].content.isCasService) {
            casCounter += 1;
            casField = i;
          } else if (value.response[i].content.isSASEService) {
            sasCounter += 1;
            sasField = i;
          } else if (value.response[i].content.isCESService) {
            cesCounter += 1;
            cesField = i;
          } else if (value.response[i].content.isSSEService) {
            sseCounter += 1;
            sseField = i;
          } else if (value.response[i].content.isTSEService) {
            tseCounter += 1;
            tseField = i;
          } else if (value.response[i].content.isTSEMDRService) {
            tsmdrCounter += 1;
            tsemdrField = i;
          } else if (value.response[i].content.isswitch) {
            switchCounter += 1;
            if (switchOptionLength < value.response[i].content.switchoptions.length) {
              switchOptionLength = value.response[i].content.switchoptions.length;
              switchField = i;
            }
          } else if (value.response[i].content.isccclinet) {
            ccClientCounter += 1;
            ccClientField = i;
          } else if (value.response[i].content.hasOwnProperty('mdrDataCenter')) {
            console.warn('mdr contact count updated');
            value.response[i].content.mdrDataCenter.length > 0 ? mdrDcListField = i : '';
          } else if (value.response[i].content.hasOwnProperty('productType')) {
            if (value.response[i].content.productType
              .toUpperCase()
              .indexOf('NSM ON-PREM') > -1) {
              console.warn(value.response[i].content.productType);
              gmsSoftwareCounter += 1;
              gmsSoftwareField = i;
            } else {
              firewallIndex.push(i);
              firewallCounter += 1;
            }
          } else {
            firewallIndex.push(i);
            firewallCounter += 1;
          }
        }
        if (firewallCounter > 0) {
          for (let i = 0; i < firewallIndex.length ; i += 1) {
            fwZT = value.response[firewallIndex[i]].content.isZeroTouch;
            if (value.response[firewallIndex[i]].content.isCSCManaged && firewallField === -1) {
              fwCSCManagement = true;
              firewallField = value.response[firewallIndex[i]].content.arrListOffSite ?  firewallIndex[i] : -1;
            }
            noNsmOnPremParentHelpText = value?.response[firewallIndex[i]]?.content?.noNsmOnPremParentHelpText || '';
            if (value.response[firewallIndex[i]].content.isGMSManaged) {
              fwGMSManagement = true;
              gmsField = value.response[firewallIndex[i]].content.arrPolicyServerResult ?  firewallIndex[i] : -1 ;
            }
            if (!value.response[firewallIndex[i]].content.isCSCManaged && arrListField === -1) {
              arrListField = value.response[firewallIndex[i]].content.arrListOffSite ?  firewallIndex[i] : -1;
            }
            if (value.response[firewallIndex[i]].content.hasOwnProperty('cloudlist')) {
              if (value.response[firewallIndex[i]].content.cloudlist.length > 1) {
                cloudTenantField = firewallIndex[i];
              }
            }
          }
        }
        if (wifiCounter > 0) {
          for (let i = 0; i < wifiIndex.length ; i += 1) {
            countryListField = wifiIndex[i];
            wfZT = value.response[wifiIndex[i]].content.isZeroTouch;
            if (value.response[wifiIndex[i]].content.isCSCManaged) {
              wfCSCManagement = true;
              wifiField = value.response[wifiIndex[i]].content.arrListOffSite ?  wifiIndex[i] : -1;
            }
            if (value.response[wifiIndex[i]].content.isGMSManaged) {
              wfGMSManagement = true;
              gmsField = value.response[wifiIndex[i]].content.arrPolicyServerResult ?  wifiIndex[i] : -1 ;
            }
          }
        }
      }
      this.managementOpt = value;

      // passing data to third step.
      this.shownPages = {
        noNsmOnPremParentHelpText,
        showCountryDropdown,
        firewallCount : firewallCounter,
        wifiCount : wifiCounter,
        hesCount : hesCounter,
        casCount : casCounter,
        hesFieldNo : hesField,
        casFieldNo : casField,
        sasCount : sasCounter,
        sasFieldNo : sasField,
        cesCount: cesCounter,
        sseCount: sseCounter,
        tseCount: tseCounter,
        tsemdrCount: tsmdrCounter,
        cesFieldNo: cesField,
        sseFieldNo: sseField,
        tseFieldNo: tseField,
        tsemdrFieldNo: tsemdrField,
        switchCount : switchCounter,
        ccClientCount : ccClientCounter,
        gmsSoftwareCount : gmsSoftwareCounter,
        ccClientFieldNo : ccClientField,
        gmsSoftwareFieldNo : gmsSoftwareField,
        switchFieldNo : switchField,
        fwCSCManaged : fwCSCManagement,
        fwGMSManaged : fwGMSManagement,
        wfCSCManaged : wfCSCManagement,
        wfGMSManaged : wfGMSManagement,
        wifiFieldNo : wifiField,
        firewallFieldNo : firewallField,
        fwZTvalue : fwZT,
        wfZTvalue : wfZT,
        countryListFieldNo : countryListField,
        captDcListFieldNo: catpDcListField,
        mdrDcListFieldNo: mdrDcListField,
        gmsFieldNo : gmsField,
        arrListFieldNo :arrListField,
        cloudTenantFieldNo : cloudTenantField,
      };
      console.warn(this.shownPages);
    } else {
      this.helpContentStep2 = [];
      this.helpContentStep3 = [];
      for (let i = 1; i < value.response.length; i += 1) {
        const resp = value.response[i].content;
        if (resp.isWifi) {
          this.helpContentStep2.push('registerSonicwave1');
          this.helpContentStep3.push('registerSonicwave2');
        } else if (resp.isHESservice) {
          this.helpContentStep2.push('registerHES1');
          if (value.response.length === 2) {
            this.helpContentStep3.push('registerHES2');
          } else {
            this.helpContentStep3.push('registerHES3');
          }
        } else if (resp.isCasService) {
          this.helpContentStep2.push('registerCas1');
          this.helpContentStep3.push('registerCas2');
        } else if (resp.isstoragesata) {
          this.helpContentStep2.push('registerSATA1');
          this.helpContentStep3.push('registerSATA2');
        } else if (resp.issecureupgrade) {
          if (value.response.length === 2) {
            this.helpContentStep2.push('registerSonicwallUpgrade1');
            this.helpContentStep2.push('registerCompitativeUpgrade1');
            this.helpContentStep3.push('registerSonicwallUpgrade2');
            this.helpContentStep3.push('registerCompitativeUpgrade2');
          } else {
            this.helpContentStep2.push('registerSonicwallUpgrade1');
            this.helpContentStep3.push('registerSonicwallUpgrade2');
          }
        } else {
          this.helpContentStep2.push('registerUTMStep1');
          this.helpContentStep3.push('registerUTMStep2');
        }
      }
      this.helpContentStep2.length > 0 ? this.helpContentStep2.push('genericRegisterHelp') : '';
      this.helpContentStep3.length > 0 ? this.helpContentStep3.push('genericRegisterHelp3') : '';
      this.resetHelpId(2);
    }
  }
  // recieving data from step 3
  managementData(value : any) {
    this.managementInputData = value;
  }

  handleCloseTz80NsmOnPremModal() {
    this.$store.commit('startLoading');
    this.tz80NsmOnPrem.showModal = false;
    this.productRegistrationRequest(this.tz80NsmOnPrem?.field);
  }

  handleTz80NsmOnPremModal(field: any) {
    const mgmtData = this.$refs.managementOption as ManagementOption;
    const { arrPolicyServerResult = [], nsmOnPremTZ80HeaderText = '', nsmOnPremTZ80ContentText = '' } = this.managementOpt?.response[field]?.content || {};
    const selectedServer = arrPolicyServerResult?.filter((ele: any) => ele?.ttserverfqdnurl === mgmtData?.fwZtIpText)[0] || '';
    this.$store.commit('stopLoading');
    this.tz80NsmOnPrem.field = field;
    this.tz80NsmOnPrem.nsmOnPremTZ80HeaderText = nsmOnPremTZ80HeaderText || '';
    this.tz80NsmOnPrem.nsmOnPremTZ80ContentText = nsmOnPremTZ80ContentText || '';
    this.tz80NsmOnPrem.nsmOnPremNodeCount = selectedServer?.nsmOnPremNodeCount || '';
    this.tz80NsmOnPrem.nsmOnPremExpirationDate = selectedServer?.NsmOnPremExpirationDate || '';
    this.tz80NsmOnPrem.showModal = true;
  }

  // starting registration process
  proceed() {
    if (this.currentStep === 2) {
      this.successResponse = [];
      this.failureResponse = [];
      this.successResponseMap = new Map();
      this.failureResponseMap = new Map();
      if (this.checkValidity()) {
        this.csvData = [];
        // calling new api
        this.$store.commit('startLoading');
        for (let i = 1 ; i < this.managementOpt.serialNumber.length; i += 1) {
          if (i > 1) {
            setTimeout(() => {
              if (this.managementOpt.response[i].content.isWifi) {
                this.pageToShow = 'WIFI';
              } else if (this.managementOpt.response[i].content.isHESservice) {
                this.pageToShow = 'HES';
              } else if (this.managementOpt.response[i].content.isCasService) {
                this.pageToShow = 'CAS';
              } else if (this.managementOpt.response[i].content.isSASEService) {
                this.pageToShow = 'SAS';
              } else if (this.managementOpt.response[i].content.isCESService) {
                this.pageToShow = 'CES';
              } else if (this.managementOpt.response[i].content.isSSEService) {
                this.pageToShow = 'SSE';
              }else if (this.managementOpt.response[i].content.isTSEService) {
                this.pageToShow = 'TSE';
              }else if (this.managementOpt.response[i].content.isTSEMDRService) {
                this.pageToShow = 'TSEMDR';
              } else if (this.managementOpt.response[i].content.isMDRService) {
                this.pageToShow = 'MDR';
              } else if (this.managementOpt.response[i].content.isswitch) {
                this.pageToShow = 'SWITCH';
              } else if (this.managementOpt.response[i].content.isccclinet) {
                this.pageToShow = 'CCCLIENT';
              } else if (this.managementOpt.response[i].content.hasOwnProperty('productType')) {
                if (this.managementOpt.response[i].content.productType
                .toUpperCase()
                .indexOf('NSM ON-PREM') > -1) {
                  this.pageToShow = 'GMS';
                } else {
                  this.pageToShow = 'firewall';
                }
              } else {
                this.pageToShow = 'firewall';
              }
              this.productRegistrationRequest(i);
            },         200);
          } else {
            if (this.managementOpt.response[i].content.isWifi) {
              this.pageToShow = 'WIFI';
            } else if (this.managementOpt.response[i].content.isHESservice) {
              this.pageToShow = 'HES';
            } else if (this.managementOpt.response[i].content.isCasService) {
              this.pageToShow = 'CAS';
            } else if (this.managementOpt.response[i].content.isSASEService) {
              this.pageToShow = 'SAS';
            } else if (this.managementOpt.response[i].content.isCESService) {
              this.pageToShow = 'CES';
            } else if (this.managementOpt.response[i].content.isSSEService) {
              this.pageToShow = 'SSE';
            } else if (this.managementOpt.response[i].content.isTSEService) {
              this.pageToShow = 'TSE';
            } else if (this.managementOpt.response[i].content.isTSEMDRService) {
              this.pageToShow = 'TSEMDR';
            } else if (this.managementOpt.response[i].content.isMDRService) {
              this.pageToShow = 'MDR';
            } else if (this.managementOpt.response[i].content.isswitch) {
              this.pageToShow = 'SWITCH';
            } else if (this.managementOpt.response[i].content.isccclinet) {
              this.pageToShow = 'CCCLIENT';
            } else if (this.managementOpt.response[i].content.hasOwnProperty('productType')) {
              if (this.managementOpt.response[i].content.productType
                .toUpperCase()
                .indexOf('NSM ON-PREM') > -1) {
                this.pageToShow = 'GMS';
              } else {
                this.pageToShow = 'firewall';
              }
            } else {
              this.pageToShow = 'firewall';
            }
            const mgmtData = this.$refs.managementOption as ManagementOption;
            const { nsmOnPremTZ80HeaderText = '' } = this.managementOpt?.response[i]?.content || {};
            if (nsmOnPremTZ80HeaderText && mgmtData?.firewallManaged === 'GMSManagement') {
              this.handleTz80NsmOnPremModal(i);
              return;
            }
            this.productRegistrationRequest(i);
          }
        }
      }
    }
    if (this.currentStep === 1 && this.moveFwd) {
      if (this.checkSecureUpgradeData()) {
        if (this.noManagementLeft) {
          this.csvData = [];
          this.successResponse = [];
          this.failureResponse = [];
          this.successResponseMap = new Map();
          this.failureResponseMap = new Map();
          // this.retrievedData(this.registerSerialData, true);
          // if (this.checkValidity()) {
          this.$store.commit('startLoading');
          this.managementOpt = this.registerSerialData;
          for (let i = 1 ; i < this.managementOpt.serialNumber.length; i += 1) {
            if (this.managementOpt.response[i].content.isccclinet) {
              this.pageToShow = 'CCCLIENT';
            } else if (this.managementOpt.response[i].content.hasOwnProperty('productType')) {
              if (this.managementOpt.response[i].content.productType.toLowerCase() === 'nsm on-prem') {
                this.pageToShow = 'GMS';
              } else {
                this.pageToShow = 'firewall';
              }
            }else {
              this.pageToShow = 'firewall';
            }
            this.productRegistrationRequest(i);
          }
          // }
        } else {
          console.warn('second');
          this.retrievedData(this.registerSerialData, true);
          this.resetHelpId(3);
          this.steps[1].state = 'complete';
          this.steps[2].state = 'active';
          this.currentStep += 1;
        }
      }
    }else if ((this.unFilteredCustomer.indexOf(this.customerNameSearch.toString()
    .trim()) >= 0 || this.customerNameSearch === '') && this.currentStep === 0) {
      if (this.customerNameSearch === '') {
        this.customerName = this.unFilteredCustomer[0];
      }
      if (this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].isCanRegister) {
        this.helpContentStep2 = [];
        this.helpContentStep2.push('register-default');
        this.helpContentStep2.push('bulkRegistration');
        this.resetHelpId(2);
        this.steps[0].state = 'complete';
        this.steps[1].state = 'active';
        this.currentStep += 1;
      } else {
        const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('products.permissionErr')
        .toString()) };
        this.$store.commit('enqueueMessage', message);
      }
    }
  }

  checkValidity() {
    this.mangOptRequiredflag = false;
    const data = this.$refs.managementOption as ManagementOption;
    if (this.shownPages.hesCount > 0 && this.shownPages.wifiCount === 0 && this.shownPages.firewallCount === 0 && this.shownPages.casCount === 0) {
      if (data.dataModel.domainName === '' || data.dataModel.confirmName === ''
      || data.dataModel.inboundIpAddress === '') {
        this.mangOptRequiredflag = true;
        return false;
      }
      if (!data.dataModel.domainName.match(this.hostNameRegex)) {
        this.mangOptRequiredflag = true;
        return false;
      }
      if (data.dataModel.confirmName !== data.dataModel.domainName) {
        this.mangOptRequiredflag = true;
        return false;
      }
      if (data.dataModel.password !== data.dataModel.confirmPassword) {
        this.mangOptRequiredflag = true;
        return false;
      }
      if (!data.ispSwitch && data.dataModel.outboundIpAddress === '') {
        this.mangOptRequiredflag = true;
        return false;
      }
      const regEx = new RegExp('(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,30}$');
      if (!regEx.test(data.dataModel.password)) {
        this.mangOptRequiredflag = true;
        return false;
      }
    }
    if (this.shownPages.casCount > 0) {
      if (data.casDomainName === '' || data.casConfirmName === '') {
        this.mangOptRequiredflag = true;
        return false;
      }
      if (data.casConfirmName !== data.casDomainName) {
        this.mangOptRequiredflag = true;
        return false;
      }
      if (!data.casDomainName.match(this.hostNameRegex)) {
        this.mangOptRequiredflag = true;
        return false;
      }
    }
    if (this.shownPages.sasCount > 0) {
      if (data.sasDomainName === '' || data.sasConfirmName === '') {
        this.mangOptRequiredflag = true;
        return false;
      }
      if (data.sasConfirmName !== data.sasDomainName) {
        this.mangOptRequiredflag = true;
        return false;
      }
      if (!data.sasDomainName.match(this.hostNameRegex)) {
        this.mangOptRequiredflag = true;
        return false;
      }
    }
    if (this.shownPages.cesCount > 0) {
      if (data.cesDomainName === '' || data.cesConfirmName === '') {
        this.mangOptRequiredflag = true;
        return false;
      }
      if (data.cesConfirmName !== data.cesDomainName) {
        this.mangOptRequiredflag = true;
        return false;
      }
      if (!data.cesDomainName.match(this.hostNameRegex)) {
        this.mangOptRequiredflag = true;
        return false;
      }
    }
    if (this.shownPages.sseCount > 0) {
      if (data.sseSubdomainName === '') {
        this.mangOptRequiredflag = true;
        return false;
      }
      if (!data.sseSubdomainName.match(this.subdomainRegex)) {
        this.mangOptRequiredflag = true;
        return false;
      }
    }
    if (this.shownPages.wifiCount > 0 && this.shownPages.showCountryDropdown) {
      if (data.countryCodeCSC === 'default' || data.countryCodeCSC === '') {
        this.mangOptRequiredflag = true;
        return false;
      }
      if (data.fwManaged === 'GMSManagement') {
        if (data.ztIpText === 'default' || data.ztIpText === '') {
          this.mangOptRequiredflag = true;
          return false;
        }
      }
    }
    if (this.shownPages.firewallCount > 0) {
      if (data.firewallManaged === 'GMSManagement') {
        if (data.fwZtIpText === 'default' || data.fwZtIpText === '') {
          this.mangOptRequiredflag = true;
          return false;
        }
      }
      if (data.pageToShow.firewallFieldNo > 0 && data.firewallManaged === 'CSCManagement') {
        if (data.arrList === 'default' || data.arrList === '') {
          this.mangOptRequiredflag = true;
          return false;
        }
      } else if (data.pageToShow.arrListFieldNo > 0) {
        if (data.arrList === 'default' || data.arrList === '') {
          this.mangOptRequiredflag = true;
          return false;
        }
      }
    }
    if (this.shownPages.captDcListFieldNo > 0) {
      if (data.selectedCATPdc === 'default' || data.selectedCATPdc === '') {
        this.mangOptRequiredflag = true;
        return false;
      }
    }
    if (this.shownPages.mdrDcListFieldNo > 0) {
      if (data.selectedMDRdc === 'default' || data.selectedMDRdc === '') {
        this.mangOptRequiredflag = true;
        return false;
      }
    }
    if (this.checkFirewallCompatible()) {
      return false;
    }
    if (this.shownPages.gmsSoftwareCount > 0) {
      // tslint:disable-next-line:max-line-length
      // if (data.gmsConfiguration.policyServer.trim().length > 0 || data.gmsConfiguration.ttserverurl.trim().length > 0 || data.gmsConfiguration.ttserverfqdn.trim().length > 0) {
        // tslint:disable-next-line:max-line-length
      if (data.gmsConfiguration.ttserverurl.trim().length > 0 || data.gmsConfiguration.ttserverfqdn.trim().length > 0) {
        if (!data.gmsConfiguration.ttserverurl.match(this.gmsRegex)) {
          this.mangOptRequiredflag = true;
          return false;
        }
        if (!data.gmsConfiguration.ttserverfqdn.match(this.gmsRegex)) {
          this.mangOptRequiredflag = true;
          return false;
        }
      }
     // } else {
     //   this.mangOptRequiredflag = true;
     //   return false;
     // }
      // }
    }
    return true;
  }

  checkFirewallCompatible() {
    const data = this.$refs.managementOption as ManagementOption;
    const sernoArr = [];
    let awsFlag =  false;
    if (this.shownPages.firewallCount > 1) {
      for (let i = 1; i < this.registerSerialData.response.length ; i += 1) {
        // tslint:disable-next-line:max-line-length
        if (this.registerSerialData.response[i]?.content?.productType?.toUpperCase() === 'FIREWALL') {
          if (data.firewallManaged === 'CSCManagement' && !this.registerSerialData.response[i].content.isCSCManaged) {
            sernoArr.push(this.registerSerialData.serialNumber[i]);
          } else if (data.firewallManaged === 'GMSManagement' && !this.registerSerialData.response[i].content.isGMSManaged) {
            sernoArr.push(this.registerSerialData.serialNumber[i]);
          } else if (data.firewallManaged === 'Unmanaged' && this.registerSerialData.response[i].content.isAWSProduct) {
            awsFlag = true;
          }
        }
      }
      if (sernoArr.length > 0) {
        let str = '';
        sernoArr.forEach((ele : any, index : any) => {
          index < sernoArr.length - 1 ? str += `${ele}, ` : str += `${ele}`;
        });
        // tslint:disable-next-line:max-line-length
        const message: InfoState = { infoType: 'failed', infoMsg: `These serial number i.e ${str} does not have ${data.firewallManaged} option. Please remove from the list and try again.` };
        this.$store.commit('enqueueMessage', message);
        return true;
      }
      if (awsFlag) {
        // tslint:disable-next-line:max-line-length
        const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('products.unManageInfo')
        .toString()) };
        this.$store.commit('enqueueMessage', message);
        return true;
      }
    }
    // checking switch compatibility
    if (this.shownPages.switchCount > 1) {
      const switchOptions = [];
      let swichErrorFlag = false;
      const serArr: any[] = [];
      console.warn(data.switchValue);
      for (let i = 1; i < this.registerSerialData.response.length ; i += 1) {
        if (this.registerSerialData.response[i].content.isswitch) {
          serArr.push(this.registerSerialData.serialNumber[i]);
          switchOptions.push(this.registerSerialData.response[i].content.switchoptions);
        }
      }
      let str = '';
      switchOptions.forEach((ele : any, index : any) => {
        let err = false;
        ele.forEach((element : any) => {
          if (element.name === data.switchValue) {
            err = true;
          }
        });
        if (!err) {
          swichErrorFlag = true;
          index < serArr.length - 1 ? str += `${serArr[index]}, ` : str += `${serArr[index]}`;
        }
      });
      if (swichErrorFlag) {
        // tslint:disable-next-line:max-line-length
        const message: InfoState = { infoType: 'failed', infoMsg: `These serial number i.e ${str} does not have selected management option. Please remove from the list and try again.` };
        this.$store.commit('enqueueMessage', message);
        return true;
      }
    }
    return false;
  }

  checkSecureUpgradeData() {
    this.mangOptRequiredflag = false;
    for (let i = 1; i < this.registerSerialData.serialNumber.length ; i += 1) {
      if (this.registerSerialData.response[i].content.issecureupgrade) {
        const secureUpdateData = this.$store.getters['MswProductsStoreModule/getSecureUpgrade'];
        if (secureUpdateData.get(i) === undefined || secureUpdateData.get(i) === '') {
          const obj : any = {};
          obj.operationStatus = 'NOK';
          obj.msgDesc = (this.$t('registerProduct.infoMsg1')
          .toString());
          this.errorMsg(obj);
          return false;
          break;
        }
        // tslint:disable-next-line:max-line-length
        if (secureUpdateData.get(i).length > 1 && secureUpdateData.get(i)[2].questionAnswer === '') {
          const obj : any = {};
          obj.operationStatus = 'NOK';
          obj.msgDesc = (this.$t('registerProduct.infoMsg1')
          .toString());
          this.errorMsg(obj);
          return false;
          break;
        }
      }
      if (this.registerSerialData.response[i].content.isstoragesata) {
        const secureUpdateData = this.$store.getters['MswProductsStoreModule/getStorageSata'];
        if (secureUpdateData.get(i) ===  undefined || secureUpdateData.get(i) === '') {
          const obj : any = {};
          obj.operationStatus = 'NOK';
          obj.msgDesc = (this.$t('registerProduct.infoMsg3')
          .toString());
          this.errorMsg(obj);
          return false;
          break;
        }
      }
      // if (this.registerSerialData.response[i].content.isFreeSerialNumber) {
      //   const secureUpdateData = this.$store.getters['MswProductsStoreModule/getFreeTrailSerNo'];
      //   console.warn(secureUpdateData);
      //   if (secureUpdateData.get(i) ===  undefined || secureUpdateData.get(i) === '') {
      //     const obj : any = {};
      //     obj.operationStatus = 'NOK';
      //     obj.msgDesc = 'Select a free trail serial number.';
      //     this.errorMsg(obj);
      //     return false;
      //     break;
      //   }
      // }
    }
    return true;
  }

  sortManagementOpt() {
    const serialNumberSorted: string[] = [];
    const friendlyNameSorted: string[] = [];
    const authCodeSorted: string[] = [];
    const responseSorted: object[] = [];
    let count = 1;
    let i = 1;
    while (count < this.managementOpt.serialNumber.length - (this.shownPages.hesCount + this.shownPages.casCount)) {
      if (this.managementOpt.response[i].content.isWifi && count < this.shownPages.wifiCount + 1) {
        this.$set(serialNumberSorted, count, this.managementOpt.serialNumber[i]);
        this.$set(friendlyNameSorted, count, this.managementOpt.friendlyName[i]);
        this.$set(authCodeSorted, count, this.managementOpt.authCode[i]);
        this.$set(responseSorted, count, this.managementOpt.authCode[i]);
        count += 1;
      } else if (count >= this.shownPages.wifiCount + 1) {
        // tslint:disable-next-line:max-line-length
        if (!this.managementOpt.response[i].content.isHESservice && !this.managementOpt.response[i].content.isCasService && !this.managementOpt.response[i].content.isWifi) {
          this.$set(serialNumberSorted, count, this.managementOpt.serialNumber[i]);
          this.$set(friendlyNameSorted, count, this.managementOpt.friendlyName[i]);
          this.$set(authCodeSorted, count, this.managementOpt.authCode[i]);
          this.$set(responseSorted, count, this.managementOpt.authCode[i]);
          count += 1;
        }
      }
      i < (this.managementOpt.serialNumber.length - 1) ? i += 1 : i = 1 ;
    }
    if (this.shownPages.hesCount > 0) {
      this.$set(serialNumberSorted, this.shownPages.wifiCount + this.shownPages.firewallCount + 1, this.managementOpt.serialNumber[this.shownPages.hesFieldNo]);
      this.$set(friendlyNameSorted, this.shownPages.wifiCount + this.shownPages.firewallCount + 1, this.managementOpt.friendlyName[this.shownPages.hesFieldNo]);
      this.$set(authCodeSorted, this.shownPages.wifiCount + this.shownPages.firewallCount + 1, this.managementOpt.authCode[this.shownPages.hesFieldNo]);
      this.$set(responseSorted, this.shownPages.wifiCount + this.shownPages.firewallCount + 1, this.managementOpt.authCode[this.shownPages.hesFieldNo]);
    }
    if (this.shownPages.casCount > 0) {
      // tslint:disable-next-line:max-line-length
      this.$set(serialNumberSorted, this.shownPages.wifiCount + this.shownPages.firewallCount + 1 + this.shownPages.hesCount, this.managementOpt.serialNumber[this.shownPages.casFieldNo]);
      // tslint:disable-next-line:max-line-length
      this.$set(friendlyNameSorted, this.shownPages.wifiCount + this.shownPages.firewallCount + 1 + this.shownPages.hesCount, this.managementOpt.friendlyName[this.shownPages.casFieldNo]);
      // tslint:disable-next-line:max-line-length
      this.$set(authCodeSorted, this.shownPages.wifiCount + this.shownPages.firewallCount + 1 + this.shownPages.hesCount, this.managementOpt.authCode[this.shownPages.casFieldNo]);
      // tslint:disable-next-line:max-line-length
      this.$set(responseSorted, this.shownPages.wifiCount + this.shownPages.firewallCount + 1 + this.shownPages.hesCount, this.managementOpt.authCode[this.shownPages.casFieldNo]);
    }
    const managementOptSorted = {
      authCode : authCodeSorted,
      serialNumber : serialNumberSorted,
      friendlyName : friendlyNameSorted,
      response : responseSorted,
    };
    return managementOptSorted;
  }
  // creating product registration request
  productRegistrationRequest(field : any) {
    const data = this.$refs.managementOption as ManagementOption;
    if (this.pageToShow === 'CAS' || this.pageToShow === 'MDR') {
      if (this.registerSerialData.response[field].content.isShowCasApp) {
        const req = {
          username : this.$store.getters.getUserId,
          serialNumber: this.registerSerialData.serialNumber[field].trim()
          .toUpperCase(),
          authCode: '',
          // tslint:disable-next-line:max-line-length
          friendlyName : this.registerSerialData.friendlyName[field].trim(),
          groupName: this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
          replacementType : '',
          productType : '',
          isZTAplies :false,
          ztValue:null,
          policyServerurl: null,
          uniqueID: '',
          dataCenterLocationID: null,
          upgradeFreeTrialSerialnumber:'',
          appName:'MSW',
          isUpgradeFreeTrial:'',
          messageAccept:'',
          arrSurveyResponse:[],
          registeronly:true,
          countryCode:'',
          iscascservicedefreg: (this.registerSerialData.response[field].content.isCasService
          || this.registerSerialData.response[field].content.isMDRService) ? 'YES' : 'NO',
          casbDataCenter: '',
          casbsubdomain:'',
          casbAppid:'',
          awsAssignToken:'',
        };
        req.casbAppid = data.casApp;
        req.casbDataCenter = this.pageToShow === 'MDR' ? data.selectedMDRdc : data.casDataCeter;
        req.casbsubdomain = data.casDomainName;
        console.warn(req);
        this.managementOpt.serialNumber.length === 2 ? this.registerProduct(req , field) : this.generateCSVReq(req, this.pageToShow);
        // this.registerProduct(req , field);
      } else {
        const req = {
          username : this.$store.getters.getUserId,
          serialNumber: this.registerSerialData.serialNumber[field].trim()
          .toUpperCase(),
          authCode: '',
          // tslint:disable-next-line:max-line-length
          friendlyName : this.registerSerialData.friendlyName[field].trim(),
          groupName: this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
          replacementType : '',
          productType : '',
          isZTAplies :false,
          ztValue:null,
          policyServerurl: null,
          uniqueID: '',
          dataCenterLocationID: null,
          upgradeFreeTrialSerialnumber:'',
          isUpgradeFreeTrial:'',
          messageAccept:'',
          arrSurveyResponse:[],
          registeronly:true,
          countryCode:'',
          iscascservicedefreg: (this.registerSerialData.response[field].content.isCasService
          || this.registerSerialData.response[field].content.isMDRService) ? 'YES' : 'NO',
          casbDataCenter: '',
          appName:'MSW',
          casbsubdomain:'',
          awsAssignToken:'',
        };
        req.casbsubdomain = data.casDomainName;
        req.casbDataCenter = this.pageToShow === 'MDR' ? data.selectedMDRdc : data.casDataCeter;
        // this.registerProduct(req , field);
        console.warn(req);
        this.managementOpt.serialNumber.length === 2 ? this.registerProduct(req , field) : this.generateCSVReq(req, this.pageToShow);
      }
    } else if (this.pageToShow === 'SAS') {
      const req = {
        username : this.$store.getters.getUserId,
        serialNumber: this.registerSerialData.serialNumber[field].trim()
          .toUpperCase(),
        authCode: '',
          // tslint:disable-next-line:max-line-length
        friendlyName : data.sasDomainName,
        groupName: this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
        replacementType : '',
        productType : '',
        isZTAplies :false,
        ztValue:null,
        policyServerurl: null,
        uniqueID: '',
        dataCenterLocationID: null,
        upgradeFreeTrialSerialnumber:'',
        isUpgradeFreeTrial:'',
        messageAccept:'',
        arrSurveyResponse:[],
        registeronly:true,
        appName:'MSW',
        countryCode:'',
        iscascservicedefreg: 'YES',
        casbDataCenter: '',
        casbsubdomain:'',
        awsAssignToken:'',
      };
      req.casbsubdomain = data.sasDomainName;
      req.casbDataCenter = data.sasDataCenter;
      this.managementOpt.serialNumber.length === 2 ? this.registerProduct(req , field) : this.generateCSVReq(req, this.pageToShow);
    } else if (this.pageToShow === 'CES') {
      const req = {
        username : this.$store.getters.getUserId,
        serialNumber: this.registerSerialData.serialNumber[field].trim()
          .toUpperCase(),
        authCode: '',
          // tslint:disable-next-line:max-line-length
        friendlyName : data.cesDomainName,
        groupName: this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
        replacementType : '',
        productType : '',
        isZTAplies :false,
        ztValue:null,
        policyServerurl: null,
        uniqueID: '',
        dataCenterLocationID: null,
        upgradeFreeTrialSerialnumber:'',
        isUpgradeFreeTrial:'',
        messageAccept:'',
        isStorageModule:false,
        storageModuleParentSerialnumber: '',
        storageAuthCode : '',
        tradeInSerialnumber: '',
        isRegisterOnly: true,
        signature : '',
        ttServerfqdnurl: '',
        isanalyticservicedefreg : 'NO',
        sbxDataCenter: '',
        cloudgmsserial : '',
        arrSurveyResponse:[],
        registeronly:true,
        appName:'MSW',
        countryCode:'',
        iscascservicedefreg: 'NO',
        casbDataCenter: '',
        casbsubdomain:'',
        awsAssignToken:'',
      };
      req.casbsubdomain = data.cesDomainName;
      req.casbDataCenter = data.cesDataCenter;
      this.managementOpt.serialNumber.length === 2 ? this.registerProduct(req , field) : this.generateCSVReq(req, this.pageToShow);
    }  else if (this.pageToShow === 'SSE') {
      const frientlyName: string = `Cloud Secure Edge - ${this.customerName}`;
      const req = {
        username : this.$store.getters.getUserId,
        serialNumber: this.registerSerialData.serialNumber[field].trim()
          .toUpperCase(),
        authCode: '',
          // tslint:disable-next-line:max-line-length
        friendlyName : frientlyName,
        groupName: this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
        replacementType : '',
        productType : '',
        isZTAplies :false,
        ztValue:null,
        policyServerurl: null,
        uniqueID: '',
        dataCenterLocationID: null,
        upgradeFreeTrialSerialnumber:'',
        isUpgradeFreeTrial:'',
        messageAccept:'',
        isStorageModule:false,
        storageModuleParentSerialnumber: '',
        storageAuthCode : '',
        tradeInSerialnumber: '',
        isRegisterOnly: true,
        signature : '',
        ttServerfqdnurl: '',
        isanalyticservicedefreg : 'NO',
        sbxDataCenter: '',
        cloudgmsserial : '',
        arrSurveyResponse:[],
        registeronly:true,
        appName:'MSW',
        countryCode:'',
        iscascservicedefreg: 'NO',
        casbDataCenter: data.sseDataCenter,
        casbsubdomain: data.sseSubdomainName,
        awsAssignToken:'',
      };
      this.registerSerialData?.response[field]?.content?.arrReplacementTypes?.forEach((ele : any) => {
        if (ele?.replacementval === this.$store.getters['MswProductsStoreModule/getSecureUpdateSelected'].get(field)) {
          req.replacementType = ele.replacementtype;
        }
      });
      const secureUpdateData = this.$store.getters['MswProductsStoreModule/getSecureUpgrade'].get(field);
      if (secureUpdateData && secureUpdateData.length > 0) {
        req.tradeInSerialnumber = secureUpdateData[0]?.tradeInSerialnumber || '';
      }
      this.managementOpt.serialNumber.length === 2 ? this.registerProduct(req , field) : this.generateCSVReq(req, this.pageToShow);
    }  else if (this.pageToShow === 'TSE') {
      const req = {
        username : this.$store.getters.getUserId,
        serialNumber: this.registerSerialData.serialNumber[field].trim()
          .toUpperCase(),
        authCode: '',
          // tslint:disable-next-line:max-line-length
        friendlyName : this.registerSerialData.friendlyName[field].trim(),
        groupName: this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
        replacementType : '',
        productType : '',
        isZTAplies :false,
        ztValue:null,
        policyServerurl: null,
        uniqueID: '',
        dataCenterLocationID: null,
        upgradeFreeTrialSerialnumber:'',
        isUpgradeFreeTrial:'',
        messageAccept:'',
        isStorageModule:false,
        storageModuleParentSerialnumber: '',
        storageAuthCode : '',
        tradeInSerialnumber: '',
        isRegisterOnly: true,
        signature : '',
        ttServerfqdnurl: '',
        isanalyticservicedefreg : 'NO',
        sbxDataCenter: '',
        cloudgmsserial : '',
        arrSurveyResponse:[],
        registeronly:true,
        appName:'MSW',
        countryCode:'',
        iscascservicedefreg: 'NO',
        casbDataCenter: data.tseDataCenter,
        casbsubdomain: '',
        awsAssignToken:'',
      };
        // console.log(req);
        // this.registerProduct(req , field);
      this.managementOpt.serialNumber.length === 2 ? this.registerProduct(req , field) : this.generateCSVReq(req, this.pageToShow);
    }else if (this.pageToShow === 'TSEMDR') {
      const req = {
        username : this.$store.getters.getUserId,
        serialNumber: this.registerSerialData.serialNumber[field].trim()
          .toUpperCase(),
        authCode: '',
          // tslint:disable-next-line:max-line-length
        friendlyName : this.registerSerialData.friendlyName[field].trim(),
        groupName: this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
        replacementType : '',
        productType : '',
        isZTAplies :true,
        ztValue:null,
        policyServerurl: null,
        uniqueID: '',
        dataCenterLocationID: null,
        upgradeFreeTrialSerialnumber:'',
        isUpgradeFreeTrial:'',
        messageAccept:'',
        isStorageModule:false,
        storageModuleParentSerialnumber: '',
        storageAuthCode : '',
        tradeInSerialnumber: '',
        isRegisterOnly: true,
        signature : '',
        ttServerfqdnurl: '',
        isanalyticservicedefreg : 'NO',
        sbxDataCenter: '',
        cloudgmsserial : '',
        arrSurveyResponse:[],
        registeronly:true,
        appName:'MSW',
        countryCode:'',
        iscascservicedefreg: 'NO',
        casbDataCenter: data.tseDataCenter,
        casbsubdomain: '',
        awsAssignToken:'',
      };
        // console.log(req);
        // this.registerProduct(req , field);
      this.managementOpt.serialNumber.length === 2 ? this.registerProduct(req , field) : this.generateCSVReq(req, this.pageToShow);
    } else if (this.pageToShow === 'HES') {
      const req = {
        arrSurveyResponse : [],
        authCode: '',
        awsAssignToken: '',
        appName:'MSW',
        countryCode: '',
        dataCenterLocationID: null,
        // tslint:disable-next-line:max-line-length
        friendlyName : this.registerSerialData.friendlyName[field].trim(),
        groupName: this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
        isHESdefreg: this.registerSerialData.response[field].content.isHESservice ? 'YES' : undefined,
        isUpgradeFreeTrial: '',
        isZTAplies: false,
        messageAccept: '',
        policyServerurl: null,
        productType: '',
        registeronly: true,
        replacementType: '',
        serialNumber: this.registerSerialData.serialNumber[field].trim()
        .toUpperCase(),
        uniqueID: '',
        upgradeFreeTrialSerialnumber: '',
        username: this.$store.getters.getUserId,
        ztValue: null,
      };
      if (this.managementOpt.serialNumber.length > 2) {
        this.generateCSVReq(req, this.pageToShow);
      } else {
        this.$store.commit('stopLoading');
        const req1 = {
          dataCenter: '',
          dataCenterValue: data.dataModel.dataCenterValue,
          domainName: data.dataModel.domainName,
          emailAddress: data.dataModel.email,
          inBoundMailServerIpAddres: data.dataModel.inboundIpAddress,
          isDomainOverride: true,
          isOutBoundChecked: data.ispSwitch,
          ispConnect: data.ispSwitch ? data.dataModel.outboundIpAddress : '',
          outBoundSourceIpAddress: data.ispSwitch ? '' : data.dataModel.outboundIpAddress,
          password: data.dataModel.password,
          serialNumber: this.hesSerialNumber,
        };
        let passwordStr = '';
        for (let i = 0; i < req1.password.length - 2 ; i += 1) {
          passwordStr += '*';
        }
        let ind : any;
        this.registerSerialData.response[field].content.hesDc.forEach((element : any, index : any) => {
          if (element.dataCenterLocationId === req1.dataCenterValue) {
            ind = index;
          }
        });
        req1.dataCenter = this.registerSerialData.response[field].content.hesDc[ind].dataCenterName;
        passwordStr += req1.password.substring(req1.password.length - 2);
        this.options = {
          status: 'normal',
          title: (this.$t('products.confirmation')
          .toString()),
          message: (h: CreateElement): VNode => { // tslint:disable-line
            return (
              <div>
                <div class="confirmationField">
                  <label>{this.$t('hostedEmailSecurity.dataCenterLocation')}</label>
                  <div>{req1.dataCenter}</div>
                </div>
                <div class="confirmationField">
                  <label>{this.$t('hostedEmailSecurity.domainName')}</label>
                  <div>{req1.domainName}</div>
                </div>
                <div class="confirmationField">
                  <label>{this.$t('hostedEmailSecurity.inboundMailServerIP')}</label>
                  <div>{req1.inBoundMailServerIpAddres}</div>
                </div>
                <div class={req1.outBoundSourceIpAddress.length > 0 ? 'confirmationField' : 'hidden'}>
                  <label>{this.$t('hostedEmailSecurity.outboundMailServerIP')}</label>
                  <div>{req1.outBoundSourceIpAddress}</div>
                </div>
                <div class={req1.isOutBoundChecked ? 'confirmationField' : 'hidden'}>
                  <label>{this.$t('hostedEmailSecurity.ispConnect')}</label>
                  <div>{req1.ispConnect} {req1.isOutBoundChecked} </div>
                </div>
                <div class="confirmationField">
                  <label>{this.$t('hostedEmailSecurity.emailAddress')}</label>
                  <div>{req1.emailAddress}</div>
                </div>
                <div class="confirmationField">
                  <label>{this.$t('hostedEmailSecurity.password')}</label>
                  <div>{passwordStr}</div>
                </div>
              </div>
            ) as VNode;
          },
          buttons: this.buttons,
        };
        confirmService.confirm(this.options)
        .then((key: any) => {
          if (key === 'yes') {
            this.$store.commit('startLoading');
            req1.password = jsEncrypt
            .getEncryptObj_msw()
            .encrypt(req1.password);
            this.$store.dispatch('MswProductsStoreModule/registerSerialNumber', req)
      .then((response) => {
        if (response.operationStatus === 'OK' || response.msgCode === 'MSWAPP:KEYALREADYUSED') {
          console.warn(this.hesSerialNumber);
          localStorage.setItem('tenants', '');
          localStorage.setItem('registered', 'true');
          this.hesSerialNumber = response.content.serialNumber ? response.content.serialNumber : this.hesSerialNumber.toUpperCase();
          req1.serialNumber = this.hesSerialNumber.toUpperCase();
          this.$store.dispatch('MswProductsStoreModule/activateHesService', req1)
      .then((res) => {
        if (res.operationStatus === 'OK') {
          if (response.msgCode === 'MSWAPP:KEYALREADYUSED') {
            const oldResponse = {
              content : { serialNumber : this.hesSerialNumber },
              msgDesc : 'Successfully Registered.',
            };
            this.successResponse.push(oldResponse);
            this.successResponseMap.set(field, oldResponse);
            this.showMessage();
          } else {
            this.successResponse.push(response);
            this.successResponseMap.set(field, response);
            this.showMessage();
          }
        } else if (res.operationStatus === 'NOK') {
          this.failureResponseMap.set(field, res);
          this.failureResponse.push(res);
          this.showMessage();
        }
      });
        } else {
          this.failureResponseMap.set(field, response);
          this.failureResponse.push(response);
          this.showMessage();
        }
      });
          }
        });
      }
    } else if (this.pageToShow === 'SWITCH') {
      const data = this.$refs.managementOption as ManagementOption;
      const req = {
        arrSurveyResponse : [],
        authCode: this.registerSerialData.authCode[field].trim()
        .replace('-', '')
        .toUpperCase(),
        awsAssignToken: '',
        appName:'MSW',
        countryCode: '',
        dataCenterLocationID: '',
        isStorageModule : false,
        storageModuleParentSerialnumber: '',
        storageAuthCode : '',
        friendlyName : this.registerSerialData.friendlyName[field].trim(),
        tradeInSerialnumber: '',
        groupName: this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
        isUpgradeFreeTrial: '',
        upgradeFreeTrialSerialnumber : '',
        isZTAplies: this.registerSerialData.response[field].content.isZeroTouch ? true : false,
        messageAccept: '',
        policyServerurl: '',
        productType: '',
        isRegisterOnly: true,
        registeronly: true,
        replacementType: '',
        serialNumber: this.registerSerialData.serialNumber[field].trim()
        .toUpperCase(),
        signature : '',
        ttServerfqdnurl: '',
        uniqueID: '',
        username: this.$store.getters.getUserId,
        ztValue: this.registerSerialData.response[field].content.isZeroTouch ? '0' : null,
        isanalyticservicedefreg : 'NO',
        sbxDataCenter: '',
        managementOptionname : data.switchValue,
      };
      this.managementOpt.serialNumber.length === 2 ? this.registerProduct(req , field) : this.generateCSVReq(req, this.pageToShow);
    } else if (this.pageToShow === 'CCCLIENT') {
      const req = {
        // tslint:disable-next-line:max-line-length
        clientDistGroup : this.registerSerialData.friendlyName[field].trim() === '' ? 'Capture Client Tenant' : this.registerSerialData.friendlyName[field].trim(),
        productId : this.registerSerialData.response[field].content.productid,
        serviceId : this.registerSerialData.response[field].content.serviceid,
        productGroupId : this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
        casbDataCenter : this.registerSerialData.response[field].content.hasOwnProperty('casDataCenter') ? data.ccClientDataCenter : '',
        activationKey : this.registerSerialData.serialNumber[field].trim()
        .toUpperCase(),
      };
      this.callTryNowAPi(req, field);
    } else if (this.pageToShow === 'GMS') {
      const data = this.$refs.managementOption as ManagementOption;
      const req = {
        arrSurveyResponse : [],
        authCode: this.registerSerialData.authCode[field].trim()
        .replace('-', '')
        .toUpperCase(),
        awsAssignToken: '',
        appName:'MSW',
        countryCode: '',
        dataCenterLocationID: '',
        isStorageModule : false,
        storageModuleParentSerialnumber: '',
        storageAuthCode : '',
        friendlyName : this.registerSerialData.friendlyName[field].trim(),
        tradeInSerialnumber: '',
        groupName: this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
        isUpgradeFreeTrial: this.noManagementLeft ? true : '',
        upgradeFreeTrialSerialnumber : this.noManagementLeft ? this.$store.getters['MswProductsStoreModule/getFreeTrailSerNo'].get(field) : '',
        isZTAplies: this.registerSerialData.response[field].content.isZeroTouch ? true : false,
        messageAccept: this.noManagementLeft ? 'YES' : '',
        policyServerurl: '',
        productType: '',
        isRegisterOnly: true,
        registeronly: true,
        replacementType: '',
        serialNumber: this.registerSerialData.serialNumber[field].trim()
        .toUpperCase(),
        signature : '',
        ttServerfqdnurl: '',
        uniqueID: '',
        username: this.$store.getters.getUserId,
        ztValue: this.registerSerialData.response[field].content.isZeroTouch ? '0' : null,
        isanalyticservicedefreg : 'NO',
        sbxDataCenter: '',
        cloudgmsserial : '',
        onpremconfig : {
          policyserverurl: this.noManagementLeft ? '' : data.gmsConfiguration.ttserverurl,
          ttserverurl: this.noManagementLeft ? '' : data.gmsConfiguration.ttserverurl,
          ttserverfqdn: this.noManagementLeft ? '' : data.gmsConfiguration.ttserverfqdn,
        },
        isOnpremDemoUpgrade: this.noManagementLeft ? 'YES' : 'NO',
      };
      if (this.registerSerialData.response[field].content.isAPT) {
        // tslint:disable-next-line:max-line-length
        req.uniqueID = this.$store.getters['MswProductsStoreModule/getUniqueID'].get(field) ? this.$store.getters['MswProductsStoreModule/getUniqueID'].get(field) : '' ;
      }

      // In case of free trail
      if (this.registerSerialData?.response[field]?.content?.isFreeSerialNumber) {
        const freeTrailSno = this.$store.getters['MswProductsStoreModule/getFreeTrailSerNo'];
        const serNo = freeTrailSno?.get(field) || '';
        if (serNo) {
          req.isUpgradeFreeTrial = 'true';
          req.upgradeFreeTrialSerialnumber = serNo;
          req.messageAccept = 'YES';
        }
      }

      this.managementOpt.serialNumber.length === 2 ? this.registerProduct(req , field) : this.generateCSVReq(req, this.pageToShow);
    } else {
      const req = {
        arrSurveyResponse : [],
        authCode: this.registerSerialData.authCode[field].trim()
        .replace('-', '')
        .toUpperCase(),
        awsAssignToken: '',
        appName:'MSW',
        countryCode: '',
        dataCenterLocationID: '',
        isStorageModule : false,
        storageModuleParentSerialnumber: '',
        storageAuthCode : '',
        friendlyName : this.registerSerialData.friendlyName[field].trim(),
        tradeInSerialnumber: '',
        groupName: this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
        isUpgradeFreeTrial: '',
        upgradeFreeTrialSerialnumber : '',
        isZTAplies: this.registerSerialData.response[field].content.isZeroTouch ? true : false,
        messageAccept: '',
        policyServerurl: '',
        productType: '',
        isRegisterOnly: true,
        registeronly: true,
        replacementType: '',
        serialNumber: this.registerSerialData.serialNumber[field].trim()
        .toUpperCase(),
        signature : '',
        ttServerfqdnurl: '',
        uniqueID: '',
        username: this.$store.getters.getUserId,
        ztValue: this.registerSerialData.response[field].content.isZeroTouch ? '0' : null,
        isanalyticservicedefreg : 'NO',
        sbxDataCenter: '',
        casbDataCenter: '',
        iscascservicedefreg: '',
        cloudgmsserial : '',
      };
      if (!this.noManagementLeft) {
        //   if (this.managementInputData.length > 0) {
        if (this.registerSerialData.response[field].content.isZeroTouch) {
          if (this.pageToShow === 'firewall') {
            if (data.firewallManaged === 'CSCManagement') {
              req.ztValue = data.cscZeroTouch ? '1' : '0';
              if (this.registerSerialData.response[field].content.hasOwnProperty('cloudlist')) {
                if (this.registerSerialData.response[field].content.cloudlist.length > 1) {
                  req.cloudgmsserial = data.cloudTenantSelected;
                }
              }
            }
            if (data.firewallManaged === 'GMSManagement') {
              req.ztValue = data.gmsZeroTouch ? '1' : '0';
            }
            if (data.firewallManaged === 'Unmanaged') {
              req.ztValue = null;
            }
          } else if (this.pageToShow === 'WIFI') {
            if (data.fwManaged === 'CSCManagement') {
              req.ztValue = data.cscZeroTouchfw ? '1' : '0';
            }
            if (data.fwManaged === 'GMSManagement') {
              req.ztValue = data.cscZeroTouchfw ? '1' : '0';
            }
            if (data.fwManaged === 'Unmanaged') {
              req.ztValue = null;
            }
          }
        } else {
          if (this.pageToShow === 'WIFI') {
            req.countryCode = this.registerSerialData.response[field].content.isWifi ? data.countryCodeCSC : null as any;
          }
          if (data.fwManaged === 'Unmanaged') {
            req.isZTAplies = true;
            req.ztValue = null;
          } else {
            req.isZTAplies = false;
          }
        }
        if (this.pageToShow === 'WIFI') {
          req.countryCode = this.registerSerialData.response[field].content.isWifi ? data.countryCodeCSC : null as any;
          if (data.fwManaged === 'GMSManagement') {
            if (data.gmsOnPremise) {
              data.gmsOnPremiseOpt.forEach((obj : any) => {
                if (obj.id === data.gmsOnPremise) {
                  req.policyServerurl = obj.value;
                  req.ttServerfqdnurl = this.registerSerialData.response[field].content.isZeroTouch ? data.ztIpText : data.gmsOnPremise;
                }
              });
            }
          }
        }
        if (this.pageToShow === 'firewall') {
          if (data.firewallManaged === 'GMSManagement' && this.registerSerialData.response[field].content.productType !== 'ON-PREM ANALYZER') {
            if (data.fwGmsOnPremise) {
              data.fwGmsOnPremiseOpt.forEach((obj : any) => {
                if (obj.id === data.fwGmsOnPremise) {
                  req.policyServerurl = obj.value;
                  req.ttServerfqdnurl = this.registerSerialData.response[field].content.isZeroTouch ? data.fwZtIpText : data.fwGmsOnPremise;
                }
              });
            }
          }
          if (data.firewallManaged === 'CSCManagement' || data.firewallManaged === 'Unmanaged' || data.firewallManaged === 'GMSManagement') {
            if (this.registerSerialData.response[field].content.arrListOffSite) {
              req.sbxDataCenter = data.selectedCATPdc;
              req.dataCenterLocationID = data.arrList;
            }
          }
        }
      }
      // case when user enters assign token
      if (this.registerSerialData.response[field].content.isAWSProduct) {
        if (this.registerSerialData.response[field].content.serialNumber) {
          req.serialNumber = this.registerSerialData.response[field].content.serialNumber.toUpperCase();
          req.authCode = this.registerSerialData.response[field].content.authCode;
          req.awsAssignToken =  this.registerSerialData.serialNumber[field].trim()
          .toUpperCase();
        } else {
          const assignToken = this.$store.getters['MswProductsStoreModule/getAssignToken'];
          if (assignToken.get(field) !==  undefined || assignToken.get(field) !== '') {
            req.awsAssignToken = assignToken.get(field);
          }
        }
      }

      // secure Upgrade case
      if (this.registerSerialData.response[field].content.issecureupgrade) {
        let secureUpdateData = this.$store.getters['MswProductsStoreModule/getSecureUpgrade'];
        secureUpdateData = secureUpdateData.get(field);
        this.registerSerialData.response[field].content.arrReplacementTypes.forEach((ele : any) => {
          console.warn(ele);
          if (ele.replacementval === this.$store.getters['MswProductsStoreModule/getSecureUpdateSelected'].get(field)) {
            req.replacementType = ele.replacementtype;
          }
        });
        if (secureUpdateData.length > 1) {
          req.replacementType = 'Competitive Replacement';
          req.arrSurveyResponse = secureUpdateData;
        } else if (secureUpdateData.length === 1) {
          console.warn(secureUpdateData[0].tradeInSerialnumber);
          if (secureUpdateData[0].tradeInSerialnumber === 'SECAAS') {
          } else if (secureUpdateData[0].tradeInSerialnumber === 'REPORT') {
            req.replacementType = 'REMOTE ANALYZER';
          } else {
            req.replacementType = 'SonicWall Replacement';
            req.tradeInSerialnumber = secureUpdateData[0].tradeInSerialnumber;
          }
        }
        console.warn(req);
        req.isRegisterOnly = this.$store.getters['MswProductsStoreModule/getRegisterOrTransfer'].get(field);
      }

      // storage sata case
      if (this.registerSerialData.response[field].content.isstoragesata) {
        let secureUpdateData = this.$store.getters['MswProductsStoreModule/getStorageSata'];
        secureUpdateData = secureUpdateData.get(field);
        if (secureUpdateData !== '') {
          req.isStorageModule = true;
          req.storageModuleParentSerialnumber = secureUpdateData[0].storageModuleParentSerialnumber;
          req.signature = this.registerSerialData.serialNumber[field].trim()
          .toUpperCase();
        }
      }

      // on prem analyzer case
      if (this.registerSerialData.response[field].content.isServiceRegister) {
        if (this.registerSerialData.response[field].content.productType.indexOf('PREM') > -1) {
          if (this.registerSerialData.response[field].content.arrListOffSite) {
            req.dataCenterLocationID = data.arrList;
          }
          req.isanalyticservicedefreg = 'YES';
        }
      }

      // In case of capture api
      if (this.registerSerialData.response[field].content.productType) {
        if (this.registerSerialData.response[field].content.productType.indexOf('Capture') > -1) {
          if (this.registerSerialData.response[field].content.arrListOffSite) {
            req.dataCenterLocationID = '';
            req.sbxDataCenter = data.selectedCATPdc;
          }
        }
      }

      // in case of free trail
      if (this.registerSerialData.response[field].content.isFreeSerialNumber) {
        const freeTrailSno = this.$store.getters['MswProductsStoreModule/getFreeTrailSerNo'];
        if (!(freeTrailSno.get(field) ===  undefined || freeTrailSno.get(field) === '')) {
          const serNo = freeTrailSno.get(field);
          if (serNo !== '') {
            req.isUpgradeFreeTrial = 'true';
            req.upgradeFreeTrialSerialnumber = serNo;
            req.messageAccept = 'YES';
            req.isZTAplies = true;
          }
        } else {
          req.isUpgradeFreeTrial = 'false';
          req.messageAccept = 'YES';
          req.isZTAplies = true;
        }
      }
      // for sno already registered
      // tslint:disable-next-line:max-line-length
      if (this.registerSerialData.response[field].content.isAPT) {
        // tslint:disable-next-line:max-line-length
        req.uniqueID = this.$store.getters['MswProductsStoreModule/getUniqueID'].get(field) ? this.$store.getters['MswProductsStoreModule/getUniqueID'].get(field) : '' ;
      }
      console.warn(this.shownPages);
      console.warn(this.registerSerialData.response[field].content.isMDRService);
      if (this.shownPages?.captDcListFieldNo > 0) {
        req.sbxDataCenter = data.selectedCATPdc;
      }
      if (this.registerSerialData.response[field].content.isMDRService) {
        req.iscascservicedefreg = 'YES';
      }
      // this.registerProduct(req , field);
      this.managementOpt.serialNumber.length === 2 ? this.registerProduct(req , field) : this.generateCSVReq(req, this.pageToShow);
    }
  }

  callTryNowAPi(req: any, field: any) {
    this.$store.dispatch('MswProductsStoreModule/tryNowApi', req)
      .then((res:any) => {
        this.$store.commit('stopLoading');
        if (res.operationStatus === 'OK') {
          this.$store.commit('DashBoardStoreModule/updateWidgetInfo', []);
          this.successResponse.push(res);
          this.successResponseMap.set(field, res);
          this.showMessage();
        } else {
          this.failureResponseMap.set(field, res);
          this.failureResponse.push(res);
          this.showMessage();
        }
      });
  }

  // creating csv req for multi reg.
  generateCSVReq(request : any, type: any) {
    const data = this.$refs.managementOption as ManagementOption;
    const inner = this.createRequestTemplate();
    inner.serialnumber = request.serialNumber;
    inner.friendlyName = request.friendlyName;
    inner.Tenantname = this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupName;
    inner.username = this.$store.getters.getUserId;
    if (type === 'CAS') {
      const dcObj : SelectOption[]  = data.casDataCenterOption.filter((item : any) => item.id === request.casbDataCenter);
      inner.Datacenter = dcObj[0].label;
      inner.casbsubdomain = request.casbsubdomain;
      if (request.casbAppid) {
        const dcObj : SelectOption[]  = data.casAppOption.filter((item : any) => item.id === request.casbAppid);
        inner.casbApp = dcObj[0].label;
      }
      this.csvData.push(inner);
    } else if (type === 'HES') {
      this.csvData.push(inner);
    } else {
      if (request.authCode !== '') {
        inner.authenticationCode = request.authCode;
      }
      if (request.ztValue === '0' || request.ztValue === '1') {
        inner.Ztsupport = request.ztValue;
      }
      if (request.awsAssignToken !== '') {
        inner.awsassighntoken = request.awsAssignToken;
      }
      if (request.replacementType !== '') {
        inner.tradeinSerialnumber = request.tradeInSerialnumber !== '' ? request.tradeInSerialnumber : '';
      }
      if (request.isStorageModule) {
        inner.storageparentserial = request.storageModuleParentSerialnumber;
      }
      if (request.dataCenterLocationID !== '') {
        const dcObj : SelectOption[]  = data.arrListOffSite.filter((item : any) => item.id === request.dataCenterLocationID);
        inner.Datacenter = dcObj[0].label;
      }
      if (request.sbxDataCenter !== '') {
        const dcObj : SelectOption[]  = data.catpDcList.filter((item : any) => item.id === request.sbxDataCenter);
        inner.sbxDataCenter = dcObj[0].id;
      }
      if (request.countryCode !== '') {
        const dcObj : any  = data.countryList.filter((item : any) => item.countryCode === request.countryCode);
        inner.countryCode = dcObj[0].name;
      }
      if (request.managementOptionname !== '' && request.managementOptionname) {
        inner.managementOptionname = request.managementOptionname;
      }
      if (request.policyServerurl !== '') {
        data.fwGmsOnPremiseOpt.forEach((obj : any) => {
          if (obj.id === data.fwGmsOnPremise) {
            const str = obj.label;
            const arr = str.split('-');
            inner.Gmsserialnumber = arr[arr.length - 1].trim();
          }
        });
      }
      this.csvData.push(inner);
    }
    if (this.csvData.length === this.registerSerialData.serialNumber.length - 1) {
      this.$store.commit('stopLoading');
      console.warn(this.csvData);
      this.multiProductRegistrationStatus(this.csvData , 'YES');
    }
  }

  createRequestTemplate() {
    const inner: any = {};
    inner['serialnumber'] = '';
    inner['authenticationCode'] = '';
    inner['friendlyName'] = '';
    inner['haprimarySerialnumber'] = '';
    inner['tradeinSerialnumber'] = '';
    inner['Ztsupport'] = '';
    inner['Tenantname'] = '';
    inner['Datacenter'] = '';
    inner['sbxDataCenter'] = '';
    inner['Gmsserialnumber'] = '';
    inner['storageparentserial'] = '';
    inner['casbApp'] = '';
    inner['casbsubdomain'] = '';
    inner['awsassighntoken'] = '';
    inner['countryCode'] = '';
    inner['username'] = this.$store.getters.getUserId;
    inner['managementOptionname'] = '';
    return inner;
  }

  // MULTI PRODUCT REG. API CALL
  // tslint:disable-next-line:no-unused
  multiProductRegistrationStatus(multiRegParams : any, actionTypeVar : any) {
    const body = {
      arrMultiProductRegistration : multiRegParams,
      isworkflow : 'YES' ,
    };
    console.warn(body);
    this.$store.commit('startLoading');
    this.$store.dispatch('MswProductsStoreModule/multipleRegistration', body)
      .then((data) => {
        console.warn(data);
        this.showMultiregModal = false;
        this.registrationValidityData = [];
        if (data.msgCode === 'MSWAPP:MULTIREGSUCCESS') {
          if (this.$store.getters.isLargeCustomer) {
            this.updateLocalForageProductCount(body);
          }
          this.multiRegMode = 'registerresult';
          console.warn(data.batchid);
          this.batchId = data.batchid;
          this.showMultiregModal = true;
          // const overlay = this.$refs.overlay as HTMLElement;
          // overlay.style.display = 'block';
        } else {
          if (data.arrRegisterSerialStatus) {
            data.arrRegisterSerialStatus.forEach((element :  any) => {
              const inner : any = [];
              inner['serialnumber'] = element['serialNumber'];
              if (element['errorMessage'] ===  undefined) {
                inner['status'] = 'Valid';
              } else {
                inner['status'] = 'Invalid';
              }
              inner['message'] = inner['status'] === 'Valid' ? 'Ready for registration.' : element['errorMessage'];
              this.registrationValidityData.push(inner);
            });
            this.multiRegMode = 'validity';
            this.showMultiregModal = true;
            console.warn(this.registrationValidityData);
          } else {
            const obj : any = {};
            obj.operationStatus = 'NOK';
            obj.msgDesc = data.msgDesc;
            this.errorMsg(obj);
          }
        }
        this.$store.commit('stopLoading');
      });
  }
  updateLocalForageProductCount(data : any) {
    this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets')
      .then((resp: any) => {
        data.arrMultiProductRegistration.forEach((ele : any) => {
          const indexName = this.registerSerialData.serialNumber.findIndex((element : any) => element === ele.serialnumber);
          const res = resp;
          const productId = this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId;
          const pgIndex = res.prodGroupLicenseStatus.findIndex((ele : any) => ele.productGroupId === productId);
          if (this.registerSerialData.response[indexName].content.hasOwnProperty('productType')) {
            if (pgIndex > -1) {
              if (this.registerSerialData.response[indexName].content.productType.toLowerCase() === 'firewall') {
                let firewallCount = parseInt(res.prodGroupLicenseStatus[pgIndex].firewallCount, 10);
                firewallCount += 1;
                console.warn(firewallCount);
                res.prodGroupLicenseStatus[pgIndex].firewallCount = firewallCount.toString();
                console.warn(res.prodGroupLicenseStatus[pgIndex]);
              } else if (this.registerSerialData.response[indexName].content.productType.toLowerCase() === 'access points') {
                let accessCount = parseInt(res.prodGroupLicenseStatus[pgIndex].accessPointsCount, 10);
                accessCount += 1;
                console.warn(accessCount);
                res.prodGroupLicenseStatus[pgIndex].accessPointsCount = accessCount.toString();
                console.warn(res.prodGroupLicenseStatus[pgIndex]);
              } else if (this.registerSerialData.response[indexName].content.productType.toLowerCase() === 'endpoints') {
                let endCount = parseInt(res.prodGroupLicenseStatus[pgIndex].endPointsCount, 10);
                endCount += 1;
                res.prodGroupLicenseStatus[pgIndex].endPointsCount = endCount.toString();
              }
            }
            console.warn(res);
            console.warn(pgIndex);
            this.saveForageData(res);
          } else {
            if (pgIndex > -1) {
              let firewallCount = parseInt(res.prodGroupLicenseStatus[pgIndex].firewallCount, 10);
              firewallCount += 1;
              res.prodGroupLicenseStatus[pgIndex].firewallCount = firewallCount.toString();
              this.saveForageData(res);
            }
          }
        });
      });
  }

  // calling api for product registration
  registerProduct(request : any , field : any) {
    this.$store.dispatch('MswProductsStoreModule/registerSerialNumber', request)
      .then((res) => {
        if (res.operationStatus === 'OK') {
          // updating firewall count for large customer
          // tslint:disable-next-line:max-line-length
          if (this.registerSerialData.response.length === 2 && this.$store.getters.isLargeCustomer) {
            this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets')
              .then((resp: any) => {
                const res = resp;
                const productId = this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId;
                const pgIndex = res.prodGroupLicenseStatus.findIndex((ele : any) => ele.productGroupId === productId);
                if (this.registerSerialData.response[field].content.hasOwnProperty('productType')) {
                  if (pgIndex > -1) {
                    if (this.registerSerialData.response[field].content.productType.toLowerCase() === 'firewall') {
                      let firewallCount = parseInt(res.prodGroupLicenseStatus[pgIndex].firewallCount, 10);
                      firewallCount += 1;
                      res.prodGroupLicenseStatus[pgIndex].firewallCount = firewallCount.toString();
                    } else if (this.registerSerialData.response[field].content.productType.toLowerCase() === 'access points') {
                      let accessCount = parseInt(res.prodGroupLicenseStatus[pgIndex].accessPointsCount, 10);
                      accessCount += 1;
                      res.prodGroupLicenseStatus[pgIndex].accessPointsCount = accessCount.toString();
                    } else if (this.registerSerialData.response[field].content.productType.toLowerCase() === 'endpoints') {
                      let endCount = parseInt(res.prodGroupLicenseStatus[pgIndex].endPointsCount, 10);
                      endCount += 1;
                      res.prodGroupLicenseStatus[pgIndex].endPointsCount = endCount.toString();
                    }
                  }
                  this.saveForageData(res);
                } else {
                  if (pgIndex > -1) {
                    let firewallCount = parseInt(res.prodGroupLicenseStatus[pgIndex].firewallCount, 10);
                    firewallCount += 1;
                    res.prodGroupLicenseStatus[pgIndex].firewallCount = firewallCount.toString();
                    this.saveForageData(res);
                  }
                }
              });
          // tslint:disable-next-line:max-line-length
          }
          if (this.cseAutoRedirect === 'YES' && this.registerSerialData?.response[field]?.content?.productType.toLowerCase() === 'cloud secure edge') {
            const request = {
              tenant: this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId,
              tileName: 'ISMSWSAFEENABLED',
            };
            this.$store.dispatch('MswProductsStoreModule/generateCSCCode', request)
            .then((resp: any) => {
              if (resp?.msgCode === 'MSWAPP:GENERATECSCACCESSCODESUCCESS') {
                const cscAccessCode = resp?.content?.accessCode;
                window.open(`${envCongif.spog_url}/muir/spog/login?code=${encodeURIComponent(cscAccessCode)}&mode=tileclick&stile=CSE&tenantid=${this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId}`, '_blank');
              }
            })
            .catch((err: any) => {
              this.$store.commit('stopLoading');
              console.error(err);
            })
            .finally(() => {
              this.$store.commit('stopLoading');
            });
          }
          setTimeout(() => {
            this.$store.commit('DashBoardStoreModule/updateWidgetInfo', []);
            this.successResponse.push(res);
            this.successResponseMap.set(field, res);
            this.showMessage();
          }, 500); // tslint:disable-line
        } else if (res.operationStatus === 'NOK') {
          this.failureResponseMap.set(field, res);
          this.failureResponse.push(res);
          this.showMessage();
        }
      });
  }

  showMessage() {
    if ((this.successResponseMap.size + this.failureResponseMap.size) === this.registerSerialData.serialNumber.length - 1) {
      if (this.registerSerialData.serialNumber.length > 2) {
        this.$store.commit('stopLoading');
        this.registrationValidityData = [];
        idb.refreshStore(PRODUCTS_STORE_NAME);
        this.successResponseMap.forEach((value : any, key: number) => {
          const inner : any = [];
          inner['serialnumber'] = this.registerSerialData.serialNumber[key];
          inner['status'] = 'Success';
          inner['message'] = value.msgDesc;
          this.registrationValidityData.push(inner);
        });
        this.failureResponseMap.forEach((value : any, key: number) => {
          const inner : any = [];
          inner['serialnumber'] = this.registerSerialData.serialNumber[key];
          inner['status'] = 'Failure';
          inner['message'] = value.msgDesc;
          this.registrationValidityData.push(inner);
        });
        this.multiRegMode = 'registerresultWF';
        this.showMultiregModal = true;
      } else if (this.registerSerialData.serialNumber.length === 2) {// taking length as two coz first element is empty always
        if (this.successResponseMap.size > 0) {
          const message: InfoState = { infoType: 'success', infoMsg: this.successResponseMap.get(1).msgDesc };
          this.$store.commit('enqueueMessage', message);
          // idb.refreshStore(PRODUCTS_STORE_NAME);
          setTimeout(() => {
            let pathRoute = '/m/feature/products?serialNumber=';
            let serNo = '';
            if (this.successResponseMap.get(1).content.serialNumber) {
              serNo = this.successResponseMap.get(1).content.serialNumber;
            } else if (this.successResponseMap.get(1)
            .hasOwnProperty('serialNumber')) {
              serNo = this.successResponseMap.get(1).serialNumber;
            } else {
              serNo = this.registerSerialData.serialNumber[1];
            }
            pathRoute += serNo;
            if (this.$store.getters.isLargeCustomer) {
              pathRoute += `&tenantName=${this.customerName}`;
              // Below line for filling the empty tenant name of the newly regd. serial in angular products list
              localStorage.setItem(LS_LASTSERIALTENANT, JSON.stringify({ serialNumber: serNo, tenant: this.customerName }));
            }
            // pathRoute += `&success=${this.successResponseMap.get(1).msgDesc}`;
            // if (this.registerSerialData.productTypeName[0]) { // to pass the product type data to product list then to detail component
            //   pathRoute += `&${this.registerSerialData.productTypeName[0]}`;
            // }
            const route = { path: pathRoute , component: productsTab };
            if (this.$store.getters.isLargeCustomer) {
              this.$store.dispatch(
      'MswProductsStoreModule/getProductsList', { isPaged:'NO', productGroupName:'', filterByProductType:'', lastRegistered:'-1', forceFetch: false })
    .then((res) => {
      const d = new Date();
      console.warn(res);
      const req = {
        associationType: '',
        casNodeCount: '0',
        ccNodeCount: '0',
        cloudBackupTab: false,
        dtExpired: '',
        dtExpiring: '',
        dtRegistrationDate: `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`,
        dtSupportExpiry: '',
        firmWareTab: false,
        firmwareStatus: '',
        firmwareVersion: '',
        friendlyName: this.registerSerialData.friendlyName[1].trim(),
        gmsNodeCount: '0',
        hesNodeCount: '0',
        id: '',
        isDeleteAllowed: 'YES',
        isDownloadAvailable: false,
        isLicenseExpired: false,
        isLicenseExpiring: false,
        isRenameAllowed: 'YES ',
        isSharedProduct: 'NO',
        isTransferAllowed: 'YES',
        isZTEnable: false,
        pID: '',
        pTab: true,
        productDesc: '',
        productGroup: this.customerName,
        productName: '',
        productType: '',
        registrationDate: this.getTodayDate(),
        releaseStatus: '',
        saseNodeCount: '0',
        serNo: this.registerSerialData.serialNumber[1],
        sharedGroupHoverText: '',
        status: 'ENABLED',
        supportExpiry: '',
        userGroups: '',
      };
      this.checkIfDeletedEarlier(req);
      const registeredDataCopy = localStorage.getItem('registeredData');
      if (registeredDataCopy !== undefined && registeredDataCopy !== null) {
        const reqArr = JSON.parse(registeredDataCopy);
        const findInd = reqArr.findIndex((ele : any) => ele.serNo.trim()
        .toLowerCase() === req.serNo.trim()
        .toLowerCase());
        if (findInd !== -1) {
          reqArr.splice(findInd, 1);
        }
        reqArr.push(req);
        localStorage.setItem('registeredData', JSON.stringify(reqArr));
      } else {
        const reqArr = [];
        reqArr.push(req);
        localStorage.setItem('registeredData', JSON.stringify(reqArr));
      }
      if (this.registerSerialData.response[1].content.isThreeandFreeCSE === 'YES' || this.registerSerialData.response[1].content.isCSESeed === 'YES') {
        this.$store.commit('stopLoading');
        this.currentStep = this.currentStep + 1;
        this.steps[2].state = 'complete';
        this.steps[3].state = 'active';
        this.threeAndFreeGroupID = this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId;
        this.cSEModal.route = route;
        this.cSEModal.path = pathRoute;

      } else {
        this.$router.replace(route);
        window.parent.postMessage({
          redirectUrl : pathRoute,
        },                        '*');
      }
    });
            } else {
              if (this.registerSerialData.response[1].content.isThreeandFreeCSE === 'YES' || this.registerSerialData.response[1].content.isCSESeed === 'YES') {
                this.$store.commit('stopLoading');
                const route = { path: pathRoute , component: productsTab };
                this.currentStep = this.currentStep + 1;
                this.steps[2].state = 'complete';
                this.steps[3].state = 'active';
                this.threeAndFreeGroupID = this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupId;
                this.cSEModal.route = route;
                this.cSEModal.path = pathRoute;
              } else {
                idb.refreshStore(PRODUCTS_STORE_NAME);
                const route = { path: pathRoute , component: productsTab };
                this.$router.replace(route);
                window.parent.postMessage({
                  redirectUrl : pathRoute,
                },                        '*');
              }
            }
          },         3000);
        } else {
          this.$store.commit('stopLoading');
          const message: InfoState = { infoType: 'failed', infoMsg: this.failureResponse[0].msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
      }
    }
  }
  checkIfDeletedEarlier(req : any) {
    const deleteProductData = localStorage.getItem('deleteProductData');
    if (deleteProductData !== undefined && deleteProductData !== null) {
      const deleteProductDataCopy = JSON.parse(deleteProductData);
      if (deleteProductDataCopy.length > 0) {
        const nodedIndex : any = [];
        deleteProductDataCopy.forEach((prod : any, index : any) => {
          if (prod.serNo.trim()
          .toLowerCase() === req.serNo.trim()
          .toLowerCase()) {
            nodedIndex.push(index);
          }
        });
        if (nodedIndex.length > 0) {
          nodedIndex.forEach((ele : any) => {
            deleteProductDataCopy.splice(ele, 1);
          });
          if (deleteProductDataCopy.length === 0) {
            localStorage.removeItem('deleteProductData');
          }
        }
      }
    }
  }
  saveDataAndRedirect(data : any, route : any, pathRoute: any) {
    this.$store.dispatch('MswProductsStoreModule/saveProductsList', data)
    .then(() => {
      this.$router.replace(route);
      window.parent.postMessage({
        redirectUrl : pathRoute,
      },                        '*');
    });
  }

  goBackToProducts() {
    console.warn(this.cancelredirectUrl);
    if (this.cancelredirectUrl === 'workspace') {
      this.$router.push({ path: '/m/feature/dashboard' });
      window.parent.postMessage({
        redirectUrl : '/m/feature/dashboard',
      },                        '*');
    } else if (this.cancelredirectUrl === 'products') {
      window.parent.postMessage({
        redirectUrl : '/m/feature/products',
      },                        '*');
      this.$router.push({ path: '/m/feature/products' });
    } else {
      window.parent.postMessage({
        redirectUrl : '/m/feature/dashboard',
      },                        '*');
      this.$router.push({ path: '/m/feature/dashboard' });
    }
  }

  created() {
    console.warn(process);
    console.warn(process.env.CSC_URL);
    console.warn(process.env.CSC_API_URL);
    this.sharedIconShowMap = new Map();
    setTimeout(() => {
      const wrapper2 = document.getElementById('searchTenants') as HTMLElement;
      if (wrapper2) {
        console.warn(wrapper2.children[0].getElementsByTagName('input'));
        wrapper2.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         500);
    console.warn('latest latest 24');
    if (this.$route.query.redirectTo === 'workspace') {
      this.cancelredirectUrl = 'workspace';
    } else if (this.$route.query.redirectTo === 'productTab') {
      this.cancelredirectUrl = 'products';
    } else {
      this.cancelredirectUrl = 'workspace';
    }
    if (this.$store.getters.isLargeCustomer) {
      this.$store.commit('startLoading');
      this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', localStorage.getItem('tenants') !== '' ? true : false)
        .then((res) => {
          // tslint:disable-next-line:max-line-length
          this.showCreateProductGroup = res.hasOwnProperty('showCreateProductGrplink') ? res.showCreateProductGrplink.toLowerCase() === 'true' ? true : false : false;
          const resp : any = {};
          resp['productGroup'] = res.prodGroupLicenseStatus;
          console.warn('brvvvvvvvvvv', resp);
          this.handleAPiResponse(resp);
        });
    } else {
      this.$store.commit('startLoading');
      this.$store.dispatch('MswProductsStoreModule/getCustomerName', 'register')
        .then((res) => {
          // tslint:disable-next-line:max-line-length
          console.warn('brvvvvvvvvvv1', res);
          this.showCreateProductGroup = res.hasOwnProperty('showCreateProductGrplink') ? res.showCreateProductGrplink.toLowerCase() === 'true' ? true : false : false;
          this.handleAPiResponse(res);
        })
        .catch((errResponse: any) => {
          this.$store.commit('stopLoading');
          this.$store.commit('enqueueMessage', {
            infoType: 'failed',
            infoMsg: errResponse.msgDesc,
          });
        });
    }
    this.$store.dispatch('getAppVersion')
    .then((result: any) => {
      this.cseAutoRedirect = result.content.cseAutoRedirect;
    });
  }
  getTodayDate() {
    const d = new Date();
    const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${monthArr[d.getMonth()]} ${d.getDate()} ${d.getFullYear()}`;
  }

  handleAPiResponse(res : any) {
    this.productGroupName = res.productGroup;
    const productObject: string = localStorage.getItem('tenants') || '';
    this.productGroupName.forEach((element : any, index : any)  => {
      this.customerNameInit.push(element.productGroupName);
      if (element.sharedGroupHoverText !== '') {
        this.sharedIconShowMap.set(index, element.sharedGroupHoverText);
        console.warn(this.sharedIconShowMap.get(index));
      }
      if (productObject !== '') {
        if (productObject.replace(/"/g,   '') === element.productGroupName) {
          this.preSelectedTenant = productObject.replace(/"/g,   '');
          console.warn(this.preSelectedTenant);
        }
      } else if (this.$route.query.tenantId) {
        if (this.$route.query.tenantId === element.productGroupId) {
          this.preSelectedTenant = element.productGroupName;
          console.warn(this.preSelectedTenant);
        }
      }
    });
    for (let i = 0; i < this.productGroupName.length; i += 1) {
      if (this.productGroupName[i].isDefaultGroup.toLowerCase() === 'true') {
        this.customerNameInit.splice(i, 1);
        this.defaultProductGroup = this.productGroupName[i].productGroupName;
        this.customerNameInit.unshift(this.defaultProductGroup);
        break;
      }
    }
    if (this.preSelectedTenant !== '') {
      const ind = this.customerNameInit.findIndex((ele : any) => ele === this.preSelectedTenant);
      if (ind !== -1) {
        console.warn(ind);
        this.selectCustomer(this.customerNameInit[ind]);
      }
    }
    if (productObject !== '') {
      this.proceed();
    }
    this.$store.commit('stopLoading');
  }

  mounted() {
    this.resetHelpId(1);
    window.addEventListener('click', this.closeUploadModal);
  }

  resetHelpId(index : any) {
    if (index === 1) {
      const temp:string[] = [];
      temp.push('register-products-1');
      this.setHelpContentId({ helpId: temp });
      // console.warn(helpContentData);
      helpContentData.forEach((node : any) => {
        if (node.helpId === 'register-products-1') {
          this.helplink = node.content;
        }
      });
      console.warn(this.helplink);
    } else if (index === 2) {
      console.warn(this.helpContentStep2);
      this.helplink = '';
      const temp:string[] = [];
      this.helpContentStep2.forEach((ele : any) => {
        temp.push(ele);
      });
      this.setHelpContentId({ helpId: temp });
      helpContentData.forEach((node : any) => {
        if (this.helpContentStep2.indexOf(node.helpId) > -1) {
          this.helplink += node.content;
        }
      });
    } else if (index === 'register-default') {
      this.helplink = '';
      const temp:string[] = [];
      temp.push('register-default');
      this.setHelpContentId({ helpId: temp });
      helpContentData.forEach((node : any) => {
        if (node.helpId === 'register-default' || node.helpId === 'bulkRegistration') {
          console.warn(node.helpId);
          this.helplink += node.content;
        }
      });
    } else if (index === 3) {
      this.helplink = '';
      const temp:string[] = [];
      console.warn(this.helpContentStep3);
      this.helpContentStep3.forEach((ele : any) => {
        temp.push(ele);
      });
      this.setHelpContentId({ helpId: temp });
      helpContentData.forEach((node : any) => {
        if (this.helpContentStep3.indexOf(node.helpId) > -1) {
          this.helplink += node.content;
        }
      });
    } else if (index === 'bulkRegistration') {
      this.helplink = '';
      const temp:string[] = [];
      temp.push('bulkRegistration');
      this.setHelpContentId({ helpId: temp });
      helpContentData.forEach((node : any) => {
        if (node.helpId === 'bulkRegistration') {
          this.helplink = node.content;
        }
      });
    }
  }
  closeModal(value : any) {
    this.errorMessage = '';
    console.warn(value);
    this.resetHelpId(2);
    this.display2 = value;
  }

  noOfFields(value : number) {
    this.noOfField = value;
  }
  // Fetching csv data.
  getData(fileTextLines :any) {
    this.csvData = [];
    if (this.checkForheader(fileTextLines[0])) {
      for (let i = 1; i < fileTextLines.length; i += 1) {
        if (fileTextLines[i] !== '') {
          const data = fileTextLines[i].split(',');
          const inner : any  = {};
          inner['serialnumber'] = data[0].trim();
          inner['authenticationCode'] = data[1].trim();
          inner['friendlyName'] = data[2].trim();
          inner['haprimarySerialnumber'] = data[3].trim();
          inner['tradeinSerialnumber'] = data[4].trim();
          inner['Ztsupport'] = data[5].trim();
          inner['Tenantname'] = this.productGroupName[this.unFilteredCustomer.indexOf(this.customerName)].productGroupName;
          inner['Datacenter'] = data[6].trim();
          inner['Gmsserialnumber'] = data[7].trim();
          inner['storageparentserial'] = data[8].trim(),
          inner['casbApp'] = data[9].trim(),
          inner['casbsubdomain'] = data[10].trim(),
          inner['awsassighntoken'] = data[11].trim(),
          inner['countryCode'] = data[12].trim(),
          inner['username'] = this.$store.getters.getUserId,
          this.csvData.push(inner);
        }
      }
      this.noOfFields = this.csvData.length;
      this.multiProductRegistrationStatus(this.csvData , 'YES');
    } else {
      const message: InfoState = { infoType: 'failed', infoMsg: (this.$t('products.invalidFileUpload')
      .toString()) };
      this.$store.commit('enqueueMessage', message);
    }
  }

  checkForheader(text : any) {
    if (((text.toUpperCase()
      .indexOf('SERIALNUMBER') > -1) && (text.toUpperCase()
      .indexOf('AUTHCODE') > -1) && (text.toUpperCase()
      .indexOf('FRIENDLYNAME') > -1) && (text.toUpperCase()
      .indexOf('HAPRIMARYSERIALNUMBER') > -1) && (text.toUpperCase()
      .indexOf('TRADEINSERIALNUMBER') > -1) && (text.toUpperCase()
      .indexOf('ZTSUPPORT') > -1) && (text.toUpperCase()
      .indexOf('DATACENTER') > -1) && (text.toUpperCase()
      .indexOf('GMSSERIALNUMBER') > -1) && (text.toUpperCase()
      .indexOf('STORAGEORSATAPARENT') > -1) && (text.toUpperCase()
      .indexOf('CASAPP') > -1) && (text.toUpperCase()
      .indexOf('CASSUBDOMAIN') > -1) && (text.toUpperCase()
      .indexOf('AWSTOKEN') > -1) && (text.toUpperCase()
      .indexOf('COUNTRY') > -1))) {
      return true;
    }
    return false;
  }

  downloadCsv() {
    if (this.currentStep === 1) {
      let csvContent = 'data:text/csv;charset=utf-8,';
      csvContent += 'SERIALNUMBER,AUTHCODE,FRIENDLYNAME,HAPRIMARYSERIALNUMBER,TRADEINSERIALNUMBER,ZTSUPPORT,DATACENTER,GMSSERIALNUMBER,STORAGEORSATAPARENT,CASAPP,CASSUBDOMAIN,AWSTOKEN,COUNTRY\r\n18B16*******,ABCDEFGH,ABCDEFGH,,,0 or 1,,,,,,,\r\n';
      const data = encodeURI(csvContent);
      const link = document.createElement('a');
      document.body.appendChild(link);
      link.setAttribute('href', data);
      link.setAttribute('download', 'multiproductregistration.csv');
      link.click();
    }
  }
  goToStep(index : any) {
    if (index < this.currentStep) {
      if (index === 0) {
        this.customerName = '';
        this.customerNameSearch = '';
        this.steps[1].state = 'default';
        this.steps[2].state = 'default';
        this.steps[0].state = 'active';
        this.resetHelpId(1);
      } else if (index === 1) {
        console.warn('clicked here');
        this.steps[1].state = 'active';
        this.steps[2].state = 'default';
        this.resetHelpId(2);
      }
      this.currentStep = index;
      if (index === 0) {
        this.noOfField = 1;
      }
      this.noManagementLeft = false;
    }
  }

  showUploadModal() {
    if (this.currentStep === 1) {
      setTimeout(() => {
        console.warn('made it true');
        this.resetHelpId('bulkRegistration');
        this.display2 = true;
      },         200);
    }
  }

  errorMsg(value: any) {
    if (value.operationStatus === 'NOK') {
      this.$store.commit('clearEnqueMessage');
      const message: InfoState = { infoType: 'failed', infoMsg: value.msgDesc };
      this.$store.commit('enqueueMessage', message);
    }
  }

  beforeDestroy() {
    const temp:string[] = [];
    temp.push('default');
    this.setHelpContentId({ helpId: temp });
    window.removeEventListener('click', this.closeUploadModal);
  }

  showTick(customer : any) {
    return (customer === this.defaultProductGroup);
  }

  goToCreateCustomer() {
    window.parent.postMessage({
      redirectUrl : '/m/feature/create-customer?redirect=true',
    },                        '*');
    this.$router.push({ path:'/m/feature/create-customer?redirect=true' });
  }
  compactTooltipValue(customer: any): TooltipDirValues {
    return {
      enabled: customer.length > 26,
      placement: 'bottom',
      content: customer,
      compact: true,
      includePopperForHover: true,
      maxWidth: 500,
    };
  }
  goBackToState(step: any = null) {
    if (step.label === '1' && step.state === 'complete') {
      this.goToStep(0);
    } else if (step.label === '2' && step.state === 'complete') {
      this.goToStep(1);
    }
  }
  closeUploadModal(event : any) {
    console.warn(this.display2);
    if (this.display2) {
      const modalElement = document.getElementById('uploadModal') as HTMLElement;
      if (!(modalElement.contains(event.target) || event.target.innerText === 'Upload .CSV for bulk registration')) {
        this.display2 = false;
        console.warn('close upload moodal');
        this.resetHelpId(2);
      }
    }
  }
  setHelpStep(value : any) {
    this.helpContentStep2 = [];
    value.forEach((ele :  any) => {
      this.helpContentStep2.push(ele);
    });
    this.resetHelpId(2);
  }
  getShowSharedIcon(index : any) {
    // const obj = this.productGroupName.filter((each: any) => each.productGroupName.toLowerCase() === customer.toLowerCase());
    // console.warn(obj[0].sharedGroupHoverText);
    // return obj[0].sharedGroupHoverText;
    // console.warn(this.sharedIconShowMap.get(index));
    return this.sharedIconShowMap.get(index);
  }
  saveForageData(newResponse : any) {
    this.$store.dispatch('MswProductsStoreModule/saveTenantList', newResponse)
      .then(() => {
      });
  }
  closeDialog() {
    this.$router.replace(this.cSEModal.route);
    window.parent.postMessage({
      redirectUrl :this.cSEModal.path,
    },                        '*');
  }
}
